import { Loader2 } from 'lucide-react'

const SearchLoader = () => {
  return (
    <div className="flex animate-fade-in items-center justify-center p-5">
      <Loader2 className="size-6 animate-spin text-white" />
    </div>
  )
}

export default SearchLoader
